import { DateTime } from 'luxon';

/**
 * Anchor server "now" to a monotonic client clock so UI can tick forward
 * without treating DateTime.now() / Date.now() as absolute wall time.
 */
export function createTimeAnchor(iso) {
	if (!iso) return null;
	const seed = DateTime.fromISO(iso, { setZone: true });
	if (!seed.isValid) return null;
	return {
		iso,
		seedMs: seed.toMillis(),
		zone: seed.zoneName,
		monoMs: typeof performance !== 'undefined' ? performance.now() : 0,
	};
}

export function liveDateTimeFromAnchor(anchor) {
	if (!anchor) return null;
	const elapsed =
		(typeof performance !== 'undefined' ? performance.now() : 0) - anchor.monoMs;
	return DateTime.fromMillis(anchor.seedMs + elapsed, { zone: anchor.zone || 'utc' });
}

export function liveIsoFromAnchor(anchor) {
	const live = liveDateTimeFromAnchor(anchor);
	return live ? live.toISO() : null;
}

/** Ms until the next server-clock minute boundary (for aligning setInterval). */
export function msUntilNextServerMinute(anchor) {
	const live = liveDateTimeFromAnchor(anchor);
	if (!live) return 60_000;
	return Math.max(0, live.endOf('minute').diff(live, 'milliseconds').milliseconds);
}
